import 'magnific-popup';

$(function () {
  $(document).ready(function () {
    if (showHtmlErb.isMoveInputCommentDefined) {
      $('#move_comment').trigger('click');
    }
  });

  // 確認ダイアログを開く
  $('.article_faq_item').click(function () {
    if (!$(this).data('articles-enquete-answer-id')) {
      return; // ログイン前の状態でアンケート回答がクリックされても何もしない
    }
    $('#articles_enquete_answer_id').val($(this).data('articles-enquete-answer-id'))
    $('#enquete_anwer').text($(this).data('enquete-choice'));
    opneMagnificPopup('popup_answer_enquete');
  });

  $('.delete_comment_confirm').click(function () {
    $('#article_comment_id').val($(this).data('article-comment-id'))
    opneMagnificPopup('popup_delete_comment');
  });

  $('.stop_comment_confirm').click(function () {
    opneMagnificPopup('popup_stop_comment');
  });

  $('.delete_article_confirm').click(function () {
    opneMagnificPopup('popup_delete_article');
  });

  // 確認ダイアログを閉じる
  $('.back').click(function () {
    $.magnificPopup.close()
  })

});

// ポップアップを開く
function opneMagnificPopup(id) {
  $.magnificPopup.open({
    items: {src: '#' + id},
    type: 'inline',
    fixedContentPos: true
  }, 0);
}